import { FC, useState, useEffect } from 'react';
import { OptimizelyRegPaywall } from './AccountCreationIterations/OptimizelyRegPaywall';
import { AuthIterationType } from './types';
import { isMobile } from '@benzinga/device-utils';

export const AccountCreationIterations: FC<AuthIterationType> = ({
  authMode,
  contentType,
  email,
  // iterationVersion,
  nextUrl,
  onLogin,
  onRegister,
  onSessionLoad,
  onSocialClicked,
  placement,
  setShowPaywall,
}) => {
  const [versionIndex, setVersionIndex] = useState<number | null>(null);
  const showMobile = isMobile();

  const closePaywall = (show: boolean) => {
    if (setShowPaywall) {
      setShowPaywall(show);
    }
  };

  useEffect(() => {
    setVersionIndex(0);
  }, []);

  if (versionIndex !== null) {
    return (
      <OptimizelyRegPaywall
        allowClose={false}
        authMode={authMode}
        contentType={contentType}
        email={email}
        isMobile={showMobile}
        nextUrl={nextUrl}
        onLogin={onLogin}
        onRegister={onRegister}
        onSessionLoad={onSessionLoad}
        onSocialClicked={onSocialClicked}
        placement={placement}
        setShowPaywall={closePaywall}
      />
    );
  } else {
    return null;
  }
};
